import { Button } from "@/shared/foundation/primitives";

import styles from "./LinkSlack.module.css";

export interface LinkSlackUnavailableProps {
  onDone: () => void;
}

/**
 * Shown for every link that cannot be used.
 *
 * Unknown, expired, and already-spent are one message on purpose: the server reports them
 * identically so that holding a guessed link tells you nothing about whether it names anyone.
 * The recovery is the same in all three cases anyway.
 */
export function LinkSlackUnavailable({ onDone }: LinkSlackUnavailableProps) {
  return (
    <div className={styles.card}>
      <h1 className={styles.heading}>This link can no longer be used</h1>
      <p className={styles.body}>
        Slack links expire, and each one works only once. Mention @Roboto in
        Slack again to get a new one.
      </p>
      <div className={styles.actions}>
        <Button variant="contained" onClick={onDone}>
          Go to Roboto
        </Button>
      </div>
    </div>
  );
}
